import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LuminexLockup } from './LuminexLogo';
import { useAuthStore } from '../store/authStore';

/**
 * Top navigation for unauthenticated public pages (HomePage, PricingPage).
 * Mirrors the in-app top bar visual language: steel/ink, ember accents, dense links.
 * If the user IS logged in, we still show this with a "Workspace" CTA.
 */
export default function PublicHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuthStore();

  const linkStyle = (active) => ({
    fontSize: 13,
    fontWeight: 600,
    color: active ? 'var(--text-1)' : 'var(--text-2)',
    padding: '8px 14px',
    borderRadius: 6,
    background: active ? 'var(--bg-3)' : 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.15s',
  });

  return (
    <header
      data-testid="public-header"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        height: 60,
        background: 'rgba(248,249,251,0.92)',
        backdropFilter: 'saturate(180%) blur(14px)',
        WebkitBackdropFilter: 'saturate(180%) blur(14px)',
        borderBottom: '1px solid var(--border-1, #E1E5EC)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        gap: 16,
      }}
    >
      <div onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <LuminexLockup iconSize={28} showDevanagari={true} />
      </div>

      <nav style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 28 }}>
        <button data-testid="nav-home" onClick={() => navigate('/')} style={linkStyle(pathname === '/')}>Home</button>
        <button data-testid="nav-pricing" onClick={() => navigate('/pricing')} style={linkStyle(pathname === '/pricing')}>Pricing</button>
      </nav>

      <div style={{ flex: 1 }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {user ? (
          <button
            data-testid="nav-workspace"
            onClick={() => navigate('/library')}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: 'none',
              background: 'var(--accent)',
              color: 'var(--bg-1, #fff)',
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Open workspace →
          </button>
        ) : (
          <>
            <button
              data-testid="nav-signin"
              onClick={() => navigate('/login')}
              style={{
                padding: '8px 14px',
                borderRadius: 6,
                border: '1px solid var(--border-1, #D9DDE3)',
                background: 'transparent',
                color: 'var(--text-1)',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Sign in
            </button>
            <button
              data-testid="nav-signup"
              onClick={() => navigate('/register')}
              style={{
                padding: '8px 16px',
                borderRadius: 6,
                border: 'none',
                background: 'var(--accent)',
                color: '#fff',
                fontSize: 13,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Get started
            </button>
          </>
        )}
      </div>
    </header>
  );
}
